import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg viewBox="0 0 1024 1024" width="1em" height="1em" focusable="false" fill="currentColor" aria-hidden="true"><path d="M102.4 146.286h819.2c55.881 0 101.669 44.617 102.4 99.328L512.146 526.629.44 245.979A101.376 101.376 0 0 1 102.4 146.286zM.439 353.499 0 850.286c0 55.296 46.08 100.498 102.4 100.498h819.2c56.32 0 102.4-45.202 102.4-100.498v-497.08l-499.712 267.85a25.746 25.746 0 0 1-24.576 0L.439 353.499z" /></svg>

const Email = React.forwardRef((props, ref) => {
  return (
    <IconBase name="email" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

Email.displayName = 'IconEmail'

export default Email
